import React from 'react';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';

import T from 'utils/T';
import ex from 'utils/ex';

import * as Luxon from 'luxon'
import PeriodButton from './PeriodButton';
import PeriodCalendarButton from './PeriodCalendarButton';

import './Period.css';
import { luxonDiffDay } from 'utils/time';

export default function Period(props) {
  const {
    children,
    ...rest
  } = props || {};

  const patient_no = Recoil.useRecoilValue(AppStore.assets.patient_no);
  const [period_start, setPeriodStart] = Recoil.useRecoilState(AppStore.assets.period_start);
  const [period_end, setPeriodEnd] = Recoil.useRecoilState(AppStore.assets.period_end);
  const luxon_start = React.useMemo(() => Luxon.DateTime.fromFormat(period_start, 'yyyyMMdd'), [period_start]);
  const luxon_end = React.useMemo(() => Luxon.DateTime.fromFormat(period_end, 'yyyyMMdd'), [period_end]);
  const startDate = React.useMemo(() => luxon_start.toFormat('yy.MM.dd'), [luxon_start]);
  const endDate = React.useMemo(() => luxon_end.toFormat('yy.MM.dd'), [luxon_end]);
  const diff_days = React.useMemo(() => luxonDiffDay(luxon_start, luxon_end), [luxon_end, luxon_start]);

  return (
    <div {...ex('Period', rest)}>
      {children}
      <div>
        조회기간 : {startDate} ~ {endDate} ({Math.abs(diff_days)+1}일)
      </div>
      <div>
        <PeriodButton {...{ days: -14 }} />
        <PeriodButton {...{ days: -30 }} />
        <PeriodButton {...{ days: -90 }} />
        <PeriodCalendarButton
          {...rest}
          {...{
            patient_no,
            luxon_start,
            luxon_end,
            setPeriodStart,
            setPeriodEnd,
          }}
        />
      </div>
    </div>
  );
}
